@if (companyFacade.inRequest$ | async) {
  <div class="app-loading-wrapper">
    <app-loading></app-loading>
  </div>
} @else {
  <div class="page-wrapper">
    <div class="html" [innerHTML]="(companyFacade.forecast$ | async)?.summary ?? ''"></div>
  </div>
}
